import { mapProps } from 'recompose'
import pick from 'ramda/src/pick'

const pickProps = keys => mapProps(props => pick(keys, props))

export default pickProps
